import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Container } from '@mui/material';
import { useCookieConsentContext } from '@use-cookie-consent/react';
import PropTypes from 'prop-types';
import MainNavBar from './MainNavBar/MainNavBar';
import MessAlert from './MessAlert';
import CookieBanner from './Cookies/CookieBanner';
import CookiePreferences from './Cookies/CookiePreferences';
import useCookies from '../../hooks/useCookies';
import { cookieStateAdapter } from '../../utils/cookieUtils';
import { openCookieBanner as openCookieBannerAction } from '../../features/layoutSlice';
import config from '../../app/config';

function Layout({ hasMainNavBar = false, search = false, maxContainerWidth = 'lg' }) {
  const [cookieConsent, setCookieConsent] = useCookies('COOKIE_CONSENT', '');
  const { acceptCookies } = useCookieConsentContext();
  const isCookieBannerOpen = useSelector((state) => state.layout.isCookieBannerOpen);
  const dispatch = useDispatch();

  // Rehydrate cookie consent preferences if the cookie is found
  React.useLayoutEffect(() => {
    if (cookieConsent === '') {
      dispatch(openCookieBanner());
    }
    if (cookieConsent !== '') {
      acceptCookies(JSON.parse(cookieConsent));
    }
  }, [dispatch, cookieConsent]); // eslint-disable-line react-hooks/exhaustive-deps

  const openCookieBanner = () => dispatch(openCookieBannerAction());

  const handleCookieSubmit = (cookieConsentLocalState) => {
    acceptCookies(cookieStateAdapter(cookieConsentLocalState, config.cookies.supportedCookies));
    setCookieConsent(JSON.stringify(cookieStateAdapter(cookieConsentLocalState, config.cookies.supportedCookies)));
  };

  return (
    <div className="App" style={{ position: 'relative' }}>
      <div style={{ width: '100%', position: 'fixed', top: 0, zIndex: 1000 }}>
        {hasMainNavBar && <MainNavBar search={search} />}
        <MessAlert />
      </div>
      <Container component="main" maxWidth={maxContainerWidth} sx={{ pt: 15 }}>
        <Outlet />
      </Container>
      {isCookieBannerOpen && <CookieBanner handleCookieSubmit={handleCookieSubmit} />}
      <CookiePreferences handleCookieSubmit={handleCookieSubmit} />
    </div>
  );
}

Layout.propTypes = {
  hasMainNavBar: PropTypes.bool,
  search: PropTypes.bool,
  maxContainerWidth: PropTypes.string,
};

export default Layout;
